var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancelVisit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 64,
    viewBox: "0 0 53 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5910",
    "data-name": "Group 5910",
    transform: "translate(0 -1.148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6179",
    "data-name": "Path 6179",
    d: "M42.008,32A16.008,16.008,0,1,0,58.016,48.008,16.008,16.008,0,0,0,42.008,32Zm8.844,22.021-2.831,2.831-6.013-6.013-6.013,6.013-2.831-2.831,6.013-6.013L33.164,42l2.831-2.831,6.013,6.013,6.013-6.013L50.852,42l-6.013,6.013Z",
    transform: "translate(-5.016 1.132)",
    fill: "#e3393c",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6180",
    "data-name": "Path 6180",
    d: "M30.013,64.017H8.482A3.485,3.485,0,0,1,5,60.535V47.179A17.2,17.2,0,0,1,22.179,30h7.664a16.868,16.868,0,0,1,2.952.26,20,20,0,0,0-2.782,33.757Z",
    transform: "translate(-5 1.131)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6294",
    "data-name": "Rectangle 6294",
    width: 22,
    height: 24,
    rx: 10,
    transform: "translate(8.958 1.148)",
    opacity: 0.1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelVisit);
export default __webpack_public_path__ + "static/media/CancelVisit.be6ff7553ced7715f5c374a612743b91.svg";
export { ForwardRef as ReactComponent };